import { render } from "./list.vue?vue&type=template&id=f1b2c9cc"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=f1b2c9cc&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__